export const isObjectEmpty = ( objectName ) => {
	return Object.keys( objectName ).length === 0;
};

export const handleDynamicClasses = ( activeStyles, hoverStyles, ...args ) => {
	const classLists = [];
	const otherClass = [ ...args ].toString().replace( /,/gi, ' ' );

	// Active styles classes
	if ( activeStyles.activeBgColor !== '' ) {
		classLists.push( 'has-active-bg-color' );
	}
	if ( activeStyles.activeTextColor !== '' ) {
		classLists.push( 'has-active-text-color' );
	}
	if ( activeStyles.activeHeadingColor !== '' ) {
		classLists.push( 'has-active-heading-color' );
	}
	if ( ! isObjectEmpty( activeStyles.activeBorder ) ) {
		classLists.push( 'has-active-border' );
	}

	// Hover styles classes
	if ( hoverStyles.hoverBgColor !== '' ) {
		classLists.push( 'has-hover-bg-color' );
	}
	if ( hoverStyles.hoverTextColor !== '' ) {
		classLists.push( 'has-hover-text-color' );
	}
	if ( hoverStyles.hoverHeadingColor !== '' ) {
		classLists.push( 'has-hover-heading-color' );
	}
	if ( ! isObjectEmpty( hoverStyles.hoverBorder ) ) {
		classLists.push( 'has-hover-border' );
	}

	return classLists.toString().replace( /,/gi, ' ' ) + ' ' + otherClass;
};

export const generateScrollSteps = ( length ) => {
	const output = [ 0 ];
	const step = 100 / length;
	let nextStep = step;

	while ( nextStep < 100 ) {
		output.push( Math.round( nextStep ) );
		nextStep += step;
	}
	return output;
};
